import React from 'react';

import { MarkdownContent } from '@backstage/core-components';

import {
  Dialog,
  DialogContent,
  Drawer,
  Typography,
  DialogTitle,
  IconButton,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useStyles } from './styles';

export const InfoDocDialog = (props: {
  dialogTitle: string;
  infoDoc: string;
  open: boolean;
  onClose?: () => void;
  variant?: 'dialog' | 'drawer';
}) => {
  const { infoDoc, open, dialogTitle, onClose, variant = 'dialog' } = props;
  const classes = useStyles();

  if (variant === 'drawer') {
    return (
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Box className={classes.infoDocDrawerContainer}>
          <Box className={classes.infoDocDrawerHeader}>
            <Typography variant="h6">{dialogTitle}</Typography>
            <IconButton
              aria-label="close"
              className={classes.infoDocCloseButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Box className={classes.infoDocDrawerContent}>
            <MarkdownContent
              content={infoDoc}
              className={classes.infoDocContent}
            />
          </Box>
        </Box>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6">{dialogTitle}</Typography>
        <IconButton
          aria-label="close"
          className={classes.infoDocCloseButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <MarkdownContent content={infoDoc} className={classes.infoDocContent} />
      </DialogContent>
    </Dialog>
  );
};
